import Search from './Search';
import Tracks from './Tracks'

const Container = () => {
    return ( <div>
        <Search/>
        <Tracks/>
        </div> );
}
 
export default Container;